import React, { useEffect } from 'react';
import { isValidLobName } from '@growth/validations';
import { pdtPush } from '@growth/pdt-push';
import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';
import { B as BANNER_TYPE, a as BottomBarDefaultText } from '../../../dist/constant-7cd90700.esm.js';
import '@growth/pdt-track';
import '@growth/browser-storage';
import '@growth/dom-event-emitter';
import '@growth/custom-hooks/useAppLinkQr';
import { a as adobeTrack } from '../../../dist/adobe-d01c3551.esm.js';
import { A as AppDownloadCtaButton } from '../../../dist/downloadCta-e6265aea.esm.js';
import { A as AppBannerPokusHOC } from '../../../dist/PokusReactHOC-bc27437b.esm.js';
import { O as OrangeCtaLarge } from '../../../dist/OrangeLargeCta-b9edc246.esm.js';
import '@growth/api-calls';
import '@growth/custom-hooks/useApiCall';
import '@growth/user-agents';
import '@growth/pokus/assign-variant';
import '@growth/auth-helpers';
import '@growth/location';
import '@growth/custom-hooks/useHasMounted';
import '@growth/pwa-helper';
import '@growth/cookies';

var _templateObject;
var BottomBarContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  height: 52px;\n  width: 100%;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 6px;\n  padding-right: 6px;\n  z-index: 100;\n"])));

var BottomBar = function BottomBar(props) {
  var lobName = props.lobName,
    _props$text = props.text,
    text = _props$text === void 0 ? BottomBarDefaultText : _props$text,
    linkDetails = props.linkDetails;
    props.hocProps;
    props.page;
  if (!isValidLobName(lobName)) {
    console.error('LobName is not valid for DownloadAppTopBanner');
  }
  var onLinkClick = function onLinkClick() {
    adobeTrack('ctaClick', {
      cta: {
        name: "bottom-bar",
        type: 'card',
        componentName: 'mweb2app'
      }
    });
    pdtPush("mweb2app", {
      event_detail: {
        event_type: "click_event",
        event_value: BANNER_TYPE.BOTTOM_BAR + "|campaign:" + (linkDetails == null ? void 0 : linkDetails.campaign)
      }
    });
  };

  /* track api call failed in pdt */
  var handleLinkApiCallFailed = function handleLinkApiCallFailed() {
    // pdt.sendPdtEvent({ event: LINK_API_FAIL_EVENT });
  };
  useEffect(function () {
    pdtPush("mweb2app", {
      event_detail: {
        event_type: "load_event",
        event_value: BANNER_TYPE.BOTTOM_BAR + "|campaign:" + (linkDetails == null ? void 0 : linkDetails.campaign)
      }
    });
  }, []);
  var textData = {
    ctaText: text.ctaText || BottomBarDefaultText.ctaText,
    ctaTextColor: text.ctaTextColor || BottomBarDefaultText.ctaTextColor,
    backgroundColor: text.backgroundColor || BottomBarDefaultText.backgroundColor
  };
  var Card = function Card() {
    return /*#__PURE__*/React.createElement(BottomBarContainer, null, /*#__PURE__*/React.createElement(OrangeCtaLarge, {
      type: "button",
      backgroundColor: textData.backgroundColor,
      textColor: textData.ctaTextColor
    }, textData.ctaText));
  };
  return /*#__PURE__*/React.createElement(AppDownloadCtaButton, {
    linkDetails: linkDetails,
    onCtaClick: function onCtaClick() {
      return onLinkClick();
    },
    onLinkApiFail: handleLinkApiCallFailed,
    CustomButton: /*#__PURE__*/React.createElement(Card, null),
    bannerType: BANNER_TYPE.BOTTOM_BAR
  });
};
var BottomBarBanner = AppBannerPokusHOC(BottomBar, BANNER_TYPE.BOTTOM_BAR);

export { BottomBarBanner, BottomBar as BottomBarBasic };
